import React, { Component } from 'react'
import throttle from 'lodash/throttle'

import styles from './styles'

class SidebarStickySection extends Component {
  constructor(props) {
    super(props)

    this.componentRef = React.createRef()

    this.state = {
      sticky: false,
      startingWindowPosition: null,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler)

    if (!this.componentRef.current) return

    this.setState({
      startingWindowPosition: this.componentRef.current.offsetTop,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  scrollHandler = throttle(() => {
    if (!this.componentRef.current) return

    if (this.state.sticky === false && window.scrollY >= this.state.startingWindowPosition) {
      this.setSticky(true)
    } else if (this.state.sticky === true && window.scrollY < this.state.startingWindowPosition) {
      this.setSticky(false)
    }
  }, 80)

  setSticky = value => this.setState({ sticky: value })

  render() {
    return (
      <div ref={this.componentRef} className={this.state.sticky ? styles.sticky : null}>
        {this.props.children}
      </div>
    )
  }
}

export default SidebarStickySection
